import React, { FC } from "react";

import { Header } from "@/components/Header";
import { Col, Flex, TStyleWidth } from "@/eworkitComponents";

interface IFiltersColProps {
  width: TStyleWidth;
  header: string;
  label?: string;
}

export const FiltersCol: FC<IFiltersColProps> = ({ width, header, label, children }) => {
  return (
    <Col width={width}>
      <Flex direction="column" innerMargin="xs" padding={["xs"]}>
        <Flex direction="row" justify="space-between">
          <Header size="xs" color="black" weight="bold">
            {header}
          </Header>
          {label && (
            <Header size="xs" color="black" weight="bold">
              {label}
            </Header>
          )}
        </Flex>

        {children}
      </Flex>
    </Col>
  );
};
